import Yup from '@utils/Yupi18n';

const Estructura = (type) =>
  Yup.object().shape({
    type: Yup.number().min(0).required('Type es requerido').label('Type'),
    idMunicipio: Yup.number()
      .nullable()
      .when('type', {
        is: 0,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required('Municipio es requerido'),
      })
      .label('Municipio'),
    Municipio: Yup.string()
      .nullable()
      .when('type', {
        is: 0,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required('Municipio es requerido'),
      })
      .label('Municipio'),
    Nombre: Yup.string().min(3).max(80).required('Nombre es requerido').label('Cargo'),
    Cargo: Yup.string().min(2).max(100).nullable(),
    Email: Yup.string()
      .trim()
      .email('Ingresa un correo válido, por ejemplo: usuario@dominio.com')
      .nullable()
      .label('Correo electrónico'),
    files: Yup.array()
      .min(1)
      .max(1)
      .of(
        Yup.object().shape({
          file: Yup.string().required('Imagen es requerida'),
        })
      )
      .required('Debe incluir exactamente una imagen'),
  });

export { Estructura };
